/**
 * Premium Underfloor Heating Store — Animation Controller
 * Handles scroll-reveal animations and counter animations.
 * Respects prefers-reduced-motion.
 */

(function () {
  'use strict';

  // Skip all animations if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    // Immediately show all reveal elements
    document.querySelectorAll('[data-premium-reveal], [data-premium-reveal-stagger]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  // --------------------------------------------------------------------------
  // Scroll Reveal Observer
  // --------------------------------------------------------------------------

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px',
    }
  );

  // Observe all reveal elements
  document.querySelectorAll('[data-premium-reveal], [data-premium-reveal-stagger]').forEach(function (el) {
    revealObserver.observe(el);
  });

  // --------------------------------------------------------------------------
  // Counter Animation
  // Elements with data-premium-counter="50" will count from 0 to 50
  // --------------------------------------------------------------------------

  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  document.querySelectorAll('[data-premium-counter]').forEach(function (el) {
    counterObserver.observe(el);
  });

  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-premium-counter'), 10);
    if (isNaN(target)) return;

    var prefix = el.getAttribute('data-counter-prefix') || '';
    var suffix = el.getAttribute('data-counter-suffix') || '';
    var duration = 1500; // ms
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);

      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);

      el.textContent = prefix + current.toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }
})();
